export const conditionOperators = Object.freeze({
  contains: "contains",
  is: "is",
  inTheLast: "in the last",
  percentageOfYes: "percentage of yes",
});

